
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/range",
      function () {
        return require("private-next-pages/range/index.js");
      }
    ]);
  